import React, { useState, useEffect } from 'react';

import styled from 'styled-components';
import Header from '../../Molecule/Card/CardHeader';
import Title from '../../Molecule/Card/CardTitle/ChartTitle';
import DounutChart from '../../Molecule/Chart/DonutChart';
import DetailButton from '../../Molecule/DetailButton';
import DefaultModal from '../../Molecule/Modal/DefaultModal';
import Spinner from '../../Molecule/Spinner';
import SimpleTable, { SimpleTableProps } from '../Table/SimpleTable';

const Component = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 476px;
  border-radius: 16px;
  padding: 24px 24px 40px 24px;
  background-color: white;
`;

const Body = styled.div`
  position: relative;
  flex: 1;
  width: 100%;
  margin-top: 24px;
`;

interface DounutChartCardProps {
  data: {
    [key: string]: string | number;
    cnt: number;
    rate: number;
  }[];
  title: string;
  isLoading: boolean;
}

const DounutChartCard = ({ data, title, isLoading }: DounutChartCardProps) => {
  const [isOpenTable, setIsOpenTable] = useState(false);
  const [tableData, setTableData] = useState<SimpleTableProps['dataSource']>(
    []
  );

  const columns: SimpleTableProps['columns'] = [
    {
      title: '디바이스',
      dataIndex: 'device',
      key: 'device',
    },
    {
      title: '방문 비율',
      dataIndex: 'rate',
      key: 'rate',

      render: function render(rate: string) {
        return <div className="accent">{rate}</div>;
      },
    },
  ];

  const onClickDetailButton = () => {
    setIsOpenTable(true);
  };

  const onClickModalClose = () => {
    setIsOpenTable(false);
  };

  useEffect(() => {
    const tempData: SimpleTableProps['dataSource'] = [];
    data.forEach((element, index) => {
      const keyArr = Object.keys(element);
      const key = keyArr[0];
      tempData.push({
        key: index,
        device: element[key],
        rate: `${element.rate}%`,
      });
    });

    setTableData(tempData);
  }, [data]);

  return (
    <Component>
      <DefaultModal
        isOpen={isOpenTable}
        title={title}
        onClickCloseButton={onClickModalClose}
      >
        <SimpleTable columns={columns} dataSource={tableData} pageSize={9} />
      </DefaultModal>
      <Header>
        <Title title={title} />
        <DetailButton onClick={onClickDetailButton} />
      </Header>
      <Body>{isLoading ? <Spinner /> : <DounutChart data={data} />}</Body>
    </Component>
  );
};

export default DounutChartCard;
